/**
 * Helper to check and filter sidebar navigation items for STD_EMPLOYEE users.
 */

import { TOP_DASHBOARD_NAV_NAME } from './topDashboardAccess';

// Array of roles that trigger this simplified employee self-service sidebar.
// You can add more roles to this array in the future.
export const STD_ROLES = ["STD_EMPLOYEE", "TEST_EMP"];

/**
 * Check if the user has any of the restricted roles
 */
export const hasStdEmployeeRole = (user) => {
  if (!user) return false;
  
  // Check primary role
  const primaryRoleCode = typeof user.primaryRole === 'string'
    ? user.primaryRole
    : user.primaryRole?.roleCode;
  if (STD_ROLES.includes(primaryRoleCode) || STD_ROLES.includes(user.role)) {
    return true;
  }
  
  // Check roles array
  if (user.roles && Array.isArray(user.roles)) {
    return user.roles.some(role => {
      if (typeof role === 'string') return STD_ROLES.includes(role);
      if (typeof role === 'object' && role) {
        return STD_ROLES.includes(role.roleCode) || STD_ROLES.includes(role.code) || STD_ROLES.includes(role.name);
      }
      return false;
    });
  }
  
  return false;
};

/**
 * Filter and flatten the sidebar groups for restricted employees
 * @param {Array} originalGroups
 * @param {{ canViewTopDashboard?: boolean }} [options]
 */
export const getStdEmployeeNavigation = (originalGroups, options = {}) => {
  const { canViewTopDashboard = false } = options;

  return originalGroups.map(group => {
    const newItems = [];
    
    group.items.forEach(item => {
      // Menu items to hide
      const namesToHide = [
        "Time & Attendance",
        "Leave Management",
        "Performance Management",
        "Self Dashboard",
        "Admin Dashboard",
        "Employee Management",
        "Setup",
        "Salary Payments",
        "Roster Management",
        "Shift Setup",
        "Roster Planner",
        "Roster Template",
        "Roster Verification",
        "Attendance Verification",
        "Device Sync Logs",
        "Daily Verification",
        "Bulk Generation",
        "Category Management",
        "Salary Component Configuration",
        "OT Approval Config",
        "Dashboard",
        "My Dashboard"
      ];
      
      if (namesToHide.includes(item.name)) {
        // Optional override: show top Overview Dashboard when permission is granted
        if (item.name === TOP_DASHBOARD_NAV_NAME && canViewTopDashboard) {
          newItems.push(item);
        }
        return; // skip this item
      }
      
      // If it is "Employee Self-Service", flatten its subItems into the top level
      if (item.name === "Employee Self-Service" && item.subItems) {
        item.subItems.forEach(subItem => {
          newItems.push({
            ...subItem,
            isSubmenu: false // Flatten it
          });
        });
        return; // skip parent container item
      }
      
      newItems.push(item);
    });
    
    return {
      ...group,
      items: newItems
    };
  }).filter(group => {
    // Group names to hide entirely
    const groupsToHide = ["Time & Attendance", "Leave Management", "Performance Management", "Payroll Management"];
    if (groupsToHide.includes(group.name)) {
      return false;
    }
    return group.items.length > 0;
  });
};
